import React from "react";

const SubTitle = ({ text, totalItems, issueTypeRecord, placedAt }) => {
  return (
    <div className="subtitle">
      <div className="subtitle-text">{text}</div>
      {placedAt === "itemSection" && (
        <div className="subtitle-circle-container d-flex align-items-center">
          {/* {issueTypeRecord.hazard > 0 ? <Circle type="concern-hazard" /> : null}
          {issueTypeRecord.recommendation > 0 ? (
            <Circle type="concern-recommendation" />
          ) : null}
          {issueTypeRecord.maintenance > 0 ? (
            <Circle type="concern-maintenance" />
          ) : null} */}
          <span className="total-items ms-2">
            {totalItems} item{totalItems > 1 ? "s" : ""}
          </span>
        </div>
      )}
    </div>
  );
};

export default SubTitle;
